import { createContext, useContext } from 'react';

import type { ValidateLinkOptions } from '@tanstack/react-router';

export interface Breadcrumb {
	title: string | undefined;
	path: ValidateLinkOptions['to'];
}

export interface BreadcrumbContextType {
	breadcrumbs: Breadcrumb[];
}

export const BreadcrumbContext = createContext<BreadcrumbContextType>({
	breadcrumbs: []
});

export function useBreadcrumbs() {
	const context = useContext(BreadcrumbContext);
	if (!context) throw new Error('useBreadcrumbs must be used within an BreadcrumbProvider');
	return context;
}
